import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    home: 'Home',
    programs: 'Programs',
    subscriptions: 'Subscriptions',
    myCar: 'My Car',
    history: 'History',
    account: 'Account',
    admin: 'Admin',
    
    // Auth
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    phone: 'Phone',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    continueWith: 'Or continue with',
    
    // Home & Brand
    welcome: 'Welcome',
    mainSlogan: 'Save time. Save money.',
    washIn5Min: 'Automatic wash in 5 minutes',
    noScratches: 'No scratches guaranteed',
    stayInCar: 'Stay in your car or step out within 15 seconds',
    plateRecognition: 'Plate recognition for online payments & subscribers',
    plateRecognitionShort: 'Plate recognition',
    quickActions: 'Quick Actions',
    buyWash: 'Buy Wash',
    subscribe: 'Subscribe',
    startNow: 'Start Now',
    discoverVipCard: 'Discover VIP Card',
    vipCardTitle: 'VIP Card',
    vipCardSubtitle: 'Every 7,000 Lek earns 1 free wash',
    freeBadge: 'FREE',
    freeWashesCount_one: 'You have {n} free wash',
    freeWashesCount_other: 'You have {n} free washes',
    
    // Chip translations (feature tags on program cards)
    chipWheels: 'Wheels & underbody',
    chipHighPressure1: 'High pressure ×1',
    chipHighPressure2: 'High pressure ×2',
    chipPreWashFoam: 'Pre-wash foam',
    chipActiveFoam: 'Active PRO foam',
    chipSpotlessDry: 'Spotless PRO drying',
    chipNoDrying: '⚠️ NO DRYING',
    chipSpotlessDrySimple: 'Spotless drying',
    chipTireShine: 'Tire shine ✨',
    chipQiri: 'Protective wax (Qiri) against salt & dust 🛡️',
    chipNanoWax: 'NANO WAX — extra mirror effect ✨',
    nanoWaxBullet1: 'Water slides right off 💧',
    nanoWaxBullet2: 'Protects from sun & sea salt ☀️🌊',
    nanoWaxBullet3: 'Shine for up to 7 days ✨',
    luxuryComboLabel: 'Luxury + Interior cleaning',
    luxuryComboHours: '07:00–19:00',
    
    // Programs
    washPrograms: 'Wash Programs',
    selectProgram: 'Select a Program',
    minutes: 'min',
    lek: 'Lek',
    mostPopular: 'Most Popular',
    theBestUnlimited: 'The Best',
    
    // Program Subtitles (translate these)
    fastSubtitle: 'Quick Rinse',
    basicSubtitle: 'Essential Clean',
    economicSubtitle: 'Smart Choice',
    standardSubtitle: 'Complete Care',
    luxurySubtitle: 'Showroom Shine',
    
    // Program Descriptions (translate these)
    fastDesc: 'Quick Rinse',
    basicDesc: 'Essential Clean',
    economicDesc: 'Smart Choice',
    standardDesc: 'Complete Care',
    luxuryDesc: 'Showroom Shine',
    
    // Subscriptions
    subscriptionPlans: 'Subscription Plans',
    perMonth: '/month',
    washes: 'washes',
    unlimited: 'Unlimited',
    everyHours: 'every 24h',
    currentPlan: 'Current Plan',
    subscribePlan: 'Subscribe now →',
    unlimitedHint: 'every 24h',
    unlimitedHomeTagline: '∞ Unlimited washes · every 24h',
    washesRemaining: 'Remaining',
    washesUsed: 'Used',
    washesIncluded: 'Included',
    youSave: 'You save',
    normalPrice: 'Normal price',
    subscriptionPrice: 'Subscription',
    
    // My Car
    myCars: 'My Vehicles',
    addCar: 'Add Vehicle',
    licensePlate: 'License Plate',
    make: 'Make',
    noCars: 'No vehicles registered yet',
    autoEntry: 'Automatic gate entry',
    
    // History
    washHistory: 'Wash History',
    noHistory: 'No wash history yet',
    completed: 'Completed',
    
    // VIP
    vipCard: 'VIP Card',
    progressToNext: 'Progress to Next Free Wash',
    useFreeWash: 'Use Free Wash',
    vipExplain: 'Every 7,000 Lek = 1 free wash',
    vipMotivation: 'Almost there! Keep going!',
    vipCongrats: 'You have free washes!',
    vipCardFront: 'Front',
    vipCardBack: 'Back',
    vipHowItWorks: 'How the VIP Card works',
    vipPaymentTerminal: 'Pay by card at the terminal',
    vipPaymentTerminalDesc: 'Tap your card at the on-site payment terminal — your wash is registered to your VIP profile.',
    vipPaymentCash: 'Pay cash at the machine',
    vipPaymentCashDesc: 'Cash payments at the machine count toward your VIP balance when scanned with your registered plate.',
    vipDisclaimer: 'Every 7,000 Lek you spend earns 1 free wash. Free washes never expire as long as your account stays active.',
    
    // Account
    editProfile: 'Edit Profile',
    language: 'Language',
    settings: 'Settings',
    save: 'Save',
    cancel: 'Cancel',
    
    // Payment
    paymentMethods: 'Payment Methods',
    addCard: 'Add Card',
    cardNumber: 'Card Number',
    expiryDate: 'Expiry Date',
    cvv: 'CVV',
    cardHolder: 'Card Holder Name',
    noCards: 'No payment methods added',
    defaultCard: 'Default',
    
    // Referrals
    inviteFriends: 'Invite Friends',
    copyLink: 'Copy Link',
    friendsInvited: 'Friends Invited',
    rewardsEarned: 'Rewards Earned',
    
    // Admin
    dashboard: 'Dashboard',
    totalUsers: 'Total Users',
    activeSubscriptions: 'Active Subscriptions',
    todayWashes: "Today's Washes",
    monthlyRevenue: 'Monthly Revenue',
    totalCars: 'Total Cars',
    revenueByType: 'Revenue by Type',
    
    // CEO tabs & metrics (Section 1)
    revenueByType: 'Revenue by type',
    capacity: 'Capacity',
    // Iter20 Task 8 — subscription window on the customer home.
    subscriptionWindowLabel: 'Active',
    plansTab: 'Subscription Plans',
    // Owner Console
    ownerConsole: 'Main Panel',
    consoleRoles: 'Roles',
    consoleVip: 'VIP',
    autoSaved: 'Auto saved',
    saveChanges: 'Save changes',
    vipThresholdLabel: 'VIP threshold (Lek)',
    vipRewardProgram: 'VIP reward program',
    secretSet: 'Secret is set (hidden)',
    addManager: 'Add Manager',
    addEmployee: 'Add Employee',
    
    // Subscription scarcity
    joinWaitlist: 'Join Waitlist',
    onWaitlist: 'You\'re on the waitlist',
    unlimitedVehicleNote: 'Linked to 1 registered vehicle',
    
    // Stripe payments
    payingWithCard: 'Opening secure checkout…',
    paymentProcessing: 'Processing payment…',
    paymentSuccess: 'Payment successful',
    paymentSuccessDesc: 'Thank you! Your purchase is now active.',
    paymentCancelled: 'Payment cancelled',
    paymentCancelledDesc: 'Your payment was cancelled. Nothing was charged.',
    paymentFailed: 'Payment could not be verified',
    backToHome: 'Back to home',

    // Counter (HomePage social proof)
    counterTemplate: '{n} cars washed this week — is yours still dirty?',

    // Role permissions (English fallbacks)
    permsManagerHeader: 'Manager — what they can see and do',
    permsEmployeeHeader: 'Employee — what they can see and do',
    perm_view_daily_revenue: 'View daily revenue',
    perm_view_monthly_revenue: 'View monthly revenue',
    perm_view_costs_margins: 'View costs & margins',
    perm_register_cash_subscription: 'Register cash subscription',
    perm_cancel_subscription: 'Cancel subscriptions',
    // Iter15 Task 9 — vehicle delete confirm
    removeVehicleTitle: 'Remove vehicle?',
    removeVehicleDesc: 'This will remove',
    remove: 'Remove',
    cancel: 'Cancel',
    vehicleRemoved: 'Vehicle removed',
    // Iter15 Task 10 — admin revenue chart
    revenueByType: 'Revenue by Type',
    txType_single_wash: 'Single wash',
    txType_subscription: 'Subscription',
    txType_cash_subscription: 'Cash subscription',
    txType_interior: 'Interior',
    txType_manual_wash: 'Manual wash',
    txType_card_payment: 'Card payment',
    txType_card_subscription: 'Card subscription',
    txType_cash_subscription_refund: 'Cash subscription refund',
    todayRevenue: "Today's revenue",
    // Iter16 Task 9 — Users sub-tabs
    staffTab: 'Staff',
    selected: 'selected',
    bulkDeleteConfirm: 'Delete selected items?',
    bulkDeleteCta: 'Delete',
    // Iter17
    subOnePlateWarning: 'This subscription applies to ONE plate only. Choose carefully — it cannot be moved later.',
    name: 'Name',
    password: 'Password',
    perm_add_employees: 'Add new employees',
    perm_edit_program_prices: 'Edit program prices',
    perm_view_customer_video_links: 'See customer story links',
    perm_view_employee_panel: 'Access the Employee panel',
    perm_edit_app_texts: 'Edit app texts inline',
    perm_register_interior_completed: 'Mark interior wash completed',
    perm_view_daily_bonus: 'See daily bonus',
    perm_view_monthly_bonus: 'See monthly bonus',
    perm_view_pending_requests: 'See pending requests',
    perm_view_marketing: 'Access marketing (WhatsApp list)',
    perm_view_time_metrics: 'Show time metrics (timer + charts)',
    perm_panel_enabled: 'Enable Employee panel',
    perm_panel_enabled_manager: 'Enable Manager panel',

    // Iter21 Task 7 — Marketing sub-tabs (en)
    marketingOffers: 'Offers',
    marketingPopups: 'Pop-ups',
    settingsShort: 'Settings',
    marketingSettingsTitle: 'Marketing Settings',
    marketingGoogleReviewUrl: 'Google Review URL',
    marketingReviewDiscount: 'Review reward discount',
    // Iter21 Task 6 — Manager KPI redesign
    bookingsTab: 'Bookings',
    // Iter21 Task 8 — Review request
    reviewRequest: 'Request review',
    reviewRequestSent: 'Code created',
    reviewOpenWhatsApp: 'Open WhatsApp',
    reviewStatusNotRequested: 'Not requested',
    reviewStatusRequested: 'Requested',
    reviewStatusCompleted: 'Completed ✅',
    reviewModalTitle: 'Google review request',
    reviewModalDesc: 'A unique discount code has been generated for this customer. Share via WhatsApp with the pre-filled message below.',
    reviewModalCode: 'Discount code',
    reviewModalDiscount: 'Discount',
    reviewModalNoPhone: 'No WhatsApp number on file — share manually.',
    // Iter19 Task 3
    selected: 'Selected',
    // Iter19 Task 4 — styled cancel-subscription dialog.
    cancelSubConfirmTitle: 'Are you sure?',
    cancelSubConfirmBody: 'This subscription will be cancelled immediately.',
    cancelSubConfirmOk: 'Cancel subscription',
    // Iter30 — VIP card number + dynamic subscription plans
    vipCardNumberLabel: 'VIP Card Number',
    vipCardNumberPlaceholder: 'e.g. 1234567890',
    vipCardNumberHelp: 'Enter the number displayed by the Awoara terminal when you tap your VIP card.',
    vipCardNumberHelpManager: 'Read the number from the Awoara terminal screen and paste it here.',
    vipCardNumberSaved: 'VIP card saved',
    ocAddPlanCta: 'Add new plan',
    ocAddPlanTitle: 'New Subscription',
    ocPlanFieldName: 'Plan name (customer-facing)',
    ocPlanFieldNameEn: 'Plan name (English)',
    ocPlanFieldPrice: 'Price (Lek/month)',
    ocPlanFieldWashes: 'Washes included',
    ocPlanFieldProgram: 'Linked wash program',
    ocPlanFieldUnlimited: 'Unlimited plan (∞ washes)',
    ocPlanFieldEarnsVip: 'Earns VIP points',
    ocPlanFieldHidden: 'Hidden (not shown to customers)',
    ocPlanCreated: 'Plan created',
    ocPlanUpdated: 'Plan updated',
    ocPlanDeleted: 'Plan deleted',
    ocPlanDelete: 'Delete plan',
    ocPlanEdit: 'Edit',
    ocPlanHiddenBadge: 'Hidden',
    // Iter19 Task 10 — Subscribers admin tab.
    subscribersTab: 'Subscribers',
    subscribersSearchPlaceholder: 'Search by plate or name',
    subscribersFilterAllPlans: 'All plans',
    subscribersEmpty: 'No active subscriptions yet.',
    subscribersOriginApp: 'App',
    subscribersOriginCash: 'Cash',
    subscribersOriginWalkin: 'Walk-in',
    subscribersActivatedOn: 'Activated',
    subscribersExpiresOn: 'Expires',
    subscribersWashesLeft: 'Washes left',
    // Iter19 Task 11
    perm_view_subscribers: 'See active subscribers',
    perm_view_customers: 'Shared Customers (CRM) access',

    // Role-gating UI strings
    cashStaffInfo: 'Visit our staff to pay in cash. The team will activate the subscription for you.',
    copyFailed: 'Copy failed — please try again',
    vipUnlimitedTitle: 'Larje Pa Limit — unlimited every 24h',
    vipUnlimitedSub: 'Your plan already gives you unlimited washes. No VIP points needed.',
    confirmDeleteTitle: 'Are you sure?',
    confirmDeleteDesc: 'This action cannot be undone.',
    delete: 'Delete',
    deleted: 'Deleted',
    cancel: 'Cancel',
    deleteSelected: 'Delete selected',
    contactsPlural: 'contacts',
    // Timer
    start: 'Start',
    // Seats & waitlist (Task 18)
    seatsOk: '{n} seats available',
    seatsWarn: 'Only {n} seats available!',
    seatsDanger: 'Only {n} seats — book now!',
    seatsFull: 'Waitlist',
    joinWaitlist: 'Join waitlist',
    waitlistJoined: 'Added to the waitlist',
    waitlistAlreadyIn: 'Already in waitlist — position',
    // Owner Console — Seats subsection
    ocSeatsTitle: 'Subscription Seats',
    ocSeatsHelp: 'Configure capacity, free seats and scarcity thresholds. Free count auto-decrements on each new subscription; nightly job adds ±1/±2 variation at 03:00 UTC.',
    capacity: 'Capacity',
    freeSeats: 'Free seats',
    warnThreshold: 'Warn threshold',
    dangerThreshold: 'Danger threshold',
    // Payments tab (Task 6)
    paymentsTitle: 'Payments',
    paymentsAppBlock: 'In-app payments',
    paymentsAppHelp: 'Card payments in-app are not available. Customers pay cash or POS on site — subscriptions are activated manually by the admin.',
    raiffeisenGateway: 'Raiffeisen Gateway',
    raiffeisenMerchantId: 'Merchant ID',
    raiffeisenApiKey: 'API Key',
    raiffeisenWebhookUrl: 'Webhook URL',
    cashAlwaysOn: 'Cash always available',
    // VIP popup (Task 8)
    vipRewardPopupTitle: 'Congratulations!',
    vipRewardPopupBody: 'You\'ve earned 1 Standard wash FREE! Come to AutoSpa5 — the camera recognizes your plate and the wash starts automatically.',
    vipRewardCredit: 'You have {n} free Standard wash(es) pending',
    portalScaloOrder: 'Order at the portal: 1) free reward, 2) subscription, 3) single payment',
    // Renewal alerts (Task 19)
    renewalExpiringTitle: '⚠️ Your subscription is expiring',
    renewalExpiring5dBody: 'Your subscription expires in {n} days. Come to AutoSpa5 to renew with cash or POS on site.',
    renewalExpiring1dBody: '⚠️ Tomorrow you lose access — renew today!',
    renewalExpiredTitle: 'Your subscription has expired',
    renewalExpiredBody: 'Renew now to keep your spot — the waitlist is active.',
    renewWithCard: 'Renew with card',
    renewLater: 'Later',
    // AI CEO tab (Task 21)
    rolesAppTexts: 'App texts — edit inline',
    rolesAppTextsHelp: 'Drag to reorder. Click any text to edit per language.',
    counterFloorLabel: 'Counter minimum value',

    // Integrations (Awoara / ANPR / POS Bankar)
    awoaraTitle: 'Awoara (Terminal)',
    awoaraDesc: 'Cash + card terminal sync',
    anprTitle: 'ANPR Camera',
    anprDesc: 'Automatic license plate recognition',
    posBankarTitle: 'Bank POS',
    posBankarDesc: 'Direct POS connection to your acquirer (BKT, Credins, Raiffeisen…)',
    fieldMerchantId: 'Merchant ID',
    fieldApiKey: 'API Key',
    fieldWebhookUrl: 'Webhook URL',
    fieldCameraIp: 'Camera IP',
    fieldEndpointUrl: 'Endpoint URL',
    fieldBankName: 'Bank name',
    fieldTerminalId: 'Terminal ID (TID)',
    fieldHostIp: 'Host / Acquirer IP',
    fieldPort: 'Port',

    // Subscription dates & expiring popups
    plateRequired: 'License plate (required)',
    subValidFrom: 'Active from',
    subValidTo: 'Expires on',
    subExpiringSoonTitle: 'Your subscription expires soon!',
    subExpiringSoonBody: 'Renew now to keep using your remaining washes without interruption.',
    subExpiredTitle: 'Your subscription has expired',
    subExpiredBody: 'Renew now to keep your VIP price and avoid losing your benefits.',
    payNowCash: 'Pay with cash',
    notNow: 'Not now',
    daysLeft: '{n} days left',
    expired: 'Expired',

    // Delete user
    deleteUserBtn: 'Delete',
    deleteUserConfirmTitle: 'Are you sure?',
    deleteUserConfirmBody: 'This action permanently deletes the user account.',
    deleteUserBlocked: 'This user has an active subscription',
    deleteUserCancel: 'Cancel',
    deleteUserOK: 'Yes, delete',
    perm_delete_users: 'Delete users',

    // VIP share template
    vipShareHeadline: "I just activated my AutoSpa5 VIP Card!",
    vipDownloadShareImage: 'Download share image',
    vipShareNow: 'Share now',
    vipShareImageReady: 'Ready to post! Save and upload as a story.',

    // Subscription pay with cash (via staff)
    payWithCashStaff: 'Pay in cash to our staff',
    whatsappNumber: 'WhatsApp number',
    whatsappRecoveryHint: 'Required to recover your account',
    emailRecoveryHint: 'Enter your account email to receive a 6-digit code',
    forgotPassword: 'Forgot password?',
    recoverAccount: 'Recover account',
    sendCodeButton: 'Send code',
    verifyCodeButton: 'Verify & set new password',
    enterOtp: 'Enter the 6-digit code',
    newPassword: 'New password',
    otpSent: 'If the email is registered, a code has been sent.',
    accountRecovered: 'Password updated. You can sign in now.',

    // Referral steps (editable from Paneli Kryesor → Rolet)
    referralStep1Title: 'Share your code',
    referralStep1Desc: 'Send your unique code to friends via WhatsApp, Facebook, Instagram or link.',
    referralStep2Title: 'Friend signs up',
    referralStep2Desc: 'They register with your referral code (free, no card required).',
    referralStep3Title: 'Friend completes their first wash',
    referralStep3Desc: 'Reward is unlocked only after their car is actually washed.',
    referralStep4Title: 'You both get rewarded',
    referralStep4Desc: 'They get 1 Basic free; you get 1 Standard free for every 5 friends who complete (max 10 rewards/month).',

    // Referral page — new 4-step layout (Task 13, iter13)
    inviteFriendsTitle: 'Invite Friends',
    inviteFriendsLead: 'Share your link, earn free Standard washes.',
    referralStepNew1Title: 'Copy your link below.',
    referralStepNew1Desc: 'It contains your unique referral code.',
    referralStepNew2Title: 'Share it with a friend',
    referralStepNew2Desc: 'WhatsApp, Facebook, Instagram or TikTok — one tap.',
    referralStepNew3Title: 'Your friend registers and does their first paid wash',
    referralStepNew3Desc: 'They\'re automatically linked to your account.',
    referralStepNew4Title: 'They get 1 Standard wash FREE. You get 1 Standard FREE for every 5 friends!',
    referralStepNew4Desc: 'Real washes only. Max 10 rewards / month.',
    copyLink: 'Copy Link',
    copiedShort: 'Copied!',
    shareWith: 'Share via',
    toNextReward: 'to next reward',
    standardWashesFree: 'Standard washes free',
    progressToNextReward: 'Progress to next reward',
    keepInviting: 'Keep inviting — almost there!',

    // Referral shareable banner (editable from Owner Console → Rolet)
    referralBannerText: 'Invite 5 friends — get 1 Standard wash FREE. Your friend gets 1 Basic wash FREE on their first wash.',
    referralBannerShared: 'Banner ready to share!',

    // Marketing tab
    marketingTab: 'Marketing',
    marketingWhatsappTitle: 'Customer WhatsApp list',
    marketingWhatsappDesc: 'All customers who registered a WhatsApp number — exportable.',
    marketingExportCsv: 'Export CSV',
    marketingTotal: '{n} customers',
    marketingNoData: 'No customers with WhatsApp yet.',

    // VIP social
    vipShareTitle: 'Share to activate your card',
    vipShareInstruction: 'Post a story on Instagram or TikTok tagging @autospa5.',
    vipNoStoryNoCard: 'Without posting the story, the VIP card is NOT activated.',
    vipStoryLinkPlaceholder: 'Paste the video link (optional)',
    vipIPostedStory: 'I posted the story',
    vipActivated: 'VIP card activated — thanks for sharing!',
    // Subscription pricing
    perWashOnly: 'You pay only {price} Lek per wash',
    monthlySubscription: 'Subscription is monthly',
    unusedWashesNotice: 'Unused washes do not roll over to next month.',
    
    // Common
    loading: 'Loading...',
    success: 'Success',
    back: 'Back',
    selectCar: 'Select Vehicle',
    pleaseSelectCar: 'Please select a vehicle',
    paymentMocked: 'Demo Mode',
    // ====== Iter22 — Multi-location / Detailing / Bookings / CRM / AI ======
    detailingTab: 'Options',
    totalUsersTab: 'Total Users',
    bookingsTab: 'Bookings',
    detailingMasterHelp: 'When ON, Liquid Glass services become bookable and a new Detailing block appears for the customer.',
    upsellLiquidGlassTitle: 'Try Liquid Glass — recommended for you',
    upsellLiquidGlassBody: 'You\'ve done 8+ premium washes in the last 60 days. Treat your car to a 3-year ceramic shine.',
    crmTotalSpent: 'Total spent',
    crmWashCount: 'Washes',
    crmReviewStatus: 'Review',
  },
  sq: {
    // Navigation
    home: 'Ballina',
    programs: 'Programet',
    subscriptions: 'Abonimet',
    myCar: 'Makina',
    history: 'Historia',
    account: 'Llogaria',
    admin: 'Admin',
    
    // Auth
    login: 'Hyr',
    register: 'Regjistrohu',
    logout: 'Dil',
    email: 'Email',
    password: 'Fjalëkalimi',
    name: 'Emri',
    phone: 'Telefoni',
    confirmPassword: 'Konfirmo Fjalëkalimin',
    forgotPassword: 'Harrove Fjalëkalimin?',
    noAccount: 'Nuk ke llogari?',
    haveAccount: 'Ke tashmë një llogari?',
    signUp: 'Regjistrohu',
    signIn: 'Hyr',
    continueWith: 'Ose vazhdo me',
    
    // Home & Brand
    welcome: 'Mirësevini',
    mainSlogan: 'Kurse kohë. Kurse lekë.',
    washIn5Min: 'Larje automatike në 5 minuta',
    noScratches: 'Pa gërvishtje të garantuara',
    stayInCar: 'Qëndro në makinë ose zbrit brenda 15 sekondave',
    plateRecognition: 'Njohje targe për pagesat online dhe abonentët',
    plateRecognitionShort: 'Njohje targe',
    quickActions: 'Veprime të Shpejta',
    buyWash: 'Bli Larje',
    subscribe: 'Abonohu',
    startNow: 'Fillo Tani',
    discoverVipCard: 'Zbulo Kartën VIP',
    vipCardTitle: 'Karta VIP',
    vipCardSubtitle: 'Çdo 7,000 Lekë të fiton 1 larje falas',
    freeBadge: 'FALAS',
    freeWashesCount_one: 'Ke {n} larje falas',
    freeWashesCount_other: 'Ke {n} larje falas',
    
    // Chip translations
    chipWheels: 'Rrota & nën-shasi',
    chipHighPressure1: 'Presion i lartë ×1',
    chipHighPressure2: 'Presion i lartë ×2',
    chipPreWashFoam: 'Shkumë para-larje',
    chipActiveFoam: 'Shkumë aktive PRO',
    chipSpotlessDry: 'Tharje PRO pa njolla',
    chipNoDrying: '⚠️ PA THARJE',
    chipSpotlessDrySimple: 'Tharje pa njolla',
    chipTireShine: 'Shkëlqim gomash ✨',
    chipQiri: 'Qiri kundër kripës & pluhurit 🛡️',
    chipNanoWax: 'NANO WAX — efekt pasqyre ekstra ✨',
    nanoWaxBullet1: 'Uji rrëshqet vetë 💧',
    nanoWaxBullet2: 'Mbron nga dielli & kripa e detit ☀️🌊',
    nanoWaxBullet3: 'Shkëlqim deri në 7 ditë ✨',
    luxuryComboLabel: 'Luxury + Pastrim i brendshëm',
    luxuryComboHours: '07:00–19:00',
    
    // Programs
    washPrograms: 'Programet e Larjes',
    selectProgram: 'Zgjidh një Program',
    minutes: 'min',
    lek: 'Lekë',
    mostPopular: 'Më i zgjedhuri',
    theBestUnlimited: 'Më i Miri',
    
    // Program Subtitles
    fastSubtitle: 'Shpëlarje e Shpejtë',
    basicSubtitle: 'Pastrim Esencial',
    economicSubtitle: 'Zgjedhje e Zgjuar',
    standardSubtitle: 'Kujdes i Plotë',
    luxurySubtitle: 'Shkëlqim Showroomi',
    
    // Program Descriptions
    fastDesc: 'Shpëlarje e Shpejtë',
    basicDesc: 'Pastrim Esencial',
    economicDesc: 'Zgjedhje e Zgjuar',
    standardDesc: 'Kujdes i Plotë',
    luxuryDesc: 'Shkëlqim Showroomi',
    
    // Subscriptions
    subscriptionPlans: 'Planet e Abonimit',
    perMonth: '/muaj',
    washes: 'larje',
    unlimited: 'Pa Limit',
    everyHours: 'çdo 24 orë',
    currentPlan: 'Plani Aktual',
    subscribePlan: 'Abonohu tani →',
    unlimitedHint: 'çdo 24 orë',
    unlimitedHomeTagline: '∞ Larje pa kufi · çdo 24 orë',
    washesRemaining: 'Të Mbetura',
    washesUsed: 'Të Përdorura',
    washesIncluded: 'Të Përfshira',
    youSave: 'Kurseni',
    normalPrice: 'Çmimi normal',
    subscriptionPrice: 'Abonimi',
    
    // My Car
    myCars: 'Automjetet e Mia',
    addCar: 'Shto Automjet',
    licensePlate: 'Targa',
    make: 'Marka',
    noCars: 'Nuk ka automjete të regjistruara',
    autoEntry: 'Hyrje automatike në portë',
    
    // History
    washHistory: 'Historia e Larjeve',
    noHistory: 'Nuk ka histori larjesh',
    completed: 'Përfunduar',
    
    // VIP
    vipCard: 'Karta VIP',
    progressToNext: 'Progres për Larjen e Radhës',
    useFreeWash: 'Përdor Larje Falas',
    vipExplain: 'Çdo 7,000 Lekë = 1 larje falas',
    vipMotivation: 'Gati je! Vazhdo kështu!',
    vipCongrats: 'Ke larje falas!',
    vipCardFront: 'Përpara',
    vipCardBack: 'Mbrapa',
    vipHowItWorks: 'Si funksionon Karta VIP',
    vipPaymentTerminal: 'Paguaj me kartë në terminal',
    vipPaymentTerminalDesc: 'Vendos kartën te terminali i pagesës — larja regjistrohet automatikisht në profilin tënd VIP.',
    vipPaymentCash: 'Paguaj me lekë te makina',
    vipPaymentCashDesc: 'Pagesat me lekë në vend regjistrohen në VIP nëse targa jote është regjistruar në aplikacion.',
    vipDisclaimer: 'Çdo 7,000 Lekë të shpenzuara fitojnë 1 larje falas. Larjet falas nuk skadojnë sa kohë llogaria mbetet aktive.',
    
    // Account
    editProfile: 'Ndrysho Profilin',
    language: 'Gjuha',
    settings: 'Opsionet',
    save: 'Ruaj',
    cancel: 'Anulo',
    
    // Payment
    paymentMethods: 'Metodat e Pagesës',
    addCard: 'Shto Kartë',
    cardNumber: 'Numri i Kartës',
    expiryDate: 'Data e Skadimit',
    cvv: 'CVV',
    cardHolder: 'Emri i Mbajtësit',
    noCards: 'Nuk ka metoda pagese',
    defaultCard: 'Kryesore',
    
    // Referrals
    inviteFriends: 'Fto Miqtë',
    copyLink: 'Kopjo Linkun',
    friendsInvited: 'Miq të Ftuar',
    rewardsEarned: 'Shpërblime të Fituara',
    
    // Admin
    dashboard: 'Paneli',
    totalUsers: 'Përdorues Total',
    activeSubscriptions: 'Abonime Aktive',
    todayWashes: 'Larjet e Sotme',
    monthlyRevenue: 'Të Ardhurat Mujore',
    totalCars: 'Automjete Total',
    revenueByType: 'Të Ardhura sipas Llojit',
    
    // CEO Dashboard
    revenueByType: 'Të Ardhurat sipas Llojit',
    capacity: 'Kapaciteti',
    // Iter20 Task 8
    subscriptionWindowLabel: 'Aktiv',
    plansTab: 'Planet e Abonimeve',
    ownerConsole: 'Paneli Kryesor',
    consoleRoles: 'Rolet',
    consoleVip: 'VIP',
    autoSaved: 'Ruajtur automatikisht',
    saveChanges: 'Ruaj Ndryshimet',
    vipThresholdLabel: 'Pragu VIP (Lek)',
    vipRewardProgram: 'Programi i shpërblimit VIP',
    secretSet: 'Çelësi sekret është caktuar (i fshehur)',
    addManager: 'Shto Menaxher',
    addEmployee: 'Shto Punonjës',
    
    // Subscription scarcity
    joinWaitlist: 'Hyr në Pritje',
    onWaitlist: 'Je në listën e pritjes',
    unlimitedVehicleNote: 'I lidhur me 1 automjet të regjistruar',
    
    // Stripe payments
    payingWithCard: 'Po hapet pagesa e sigurt…',
    paymentProcessing: 'Po përpunohet pagesa…',
    paymentSuccess: 'Pagesa u krye',
    paymentSuccessDesc: 'Faleminderit! Blerja jote është aktivizuar.',
    paymentCancelled: 'Pagesa u anulua',
    paymentCancelledDesc: 'Pagesa u anulua. Asgjë nuk u tërhoq nga karta.',
    paymentFailed: 'Pagesa nuk u verifikua',
    backToHome: 'Kthehu në ballinë',

    // Counter (HomePage social proof)
    counterTemplate: '{n} makina u lanë këtë javë, e jotja akoma e pistë?',

    // Role permissions (Shqip — DEFAULT LANG)
    permsManagerHeader: 'Menaxheri — çfarë sheh dhe çfarë mund të bëjë',
    permsEmployeeHeader: 'Punonjësi — çfarë sheh dhe çfarë mund të bëjë',
    perm_view_daily_revenue: 'Shiko të ardhurat ditore',
    perm_view_monthly_revenue: 'Shiko të ardhurat mujore',
    perm_view_costs_margins: 'Shiko kostot dhe marzhet',
    perm_register_cash_subscription: 'Regjistro abonim me cash',
    perm_cancel_subscription: 'Anulo abonime',
    // Iter21 Task 7 — Marketing sub-tabs (sq)
    marketingOffers: 'Ofertat',
    marketingPopups: 'Pop-up',
    settingsShort: 'Opsionet',
    marketingSettingsTitle: 'Opsionet e Marketingut',
    marketingGoogleReviewUrl: 'Linku Google Review',
    marketingReviewDiscount: 'Zbritja për recensione',
    // Iter21 Task 6 — KPI manager (sq)
    bookingsTab: 'Rezervimet',
    // Iter21 Task 8 — Review request (sq)
    reviewRequest: 'Kërko Recensione',
    reviewRequestSent: 'Kodi u krijua',
    reviewOpenWhatsApp: 'Hap WhatsApp',
    reviewStatusNotRequested: 'E pakërkuar',
    reviewStatusRequested: 'E kërkuar',
    reviewStatusCompleted: 'E lënë ✅',
    reviewModalTitle: 'Kërkesë recensioni Google',
    reviewModalDesc: 'U gjenerua një kod zbritjeje unik për këtë klient. Ndaje në WhatsApp me mesazhin më poshtë.',
    reviewModalCode: 'Kodi i zbritjes',
    reviewModalDiscount: 'Zbritja',
    reviewModalNoPhone: 'Asnjë numër WhatsApp i regjistruar — ndaje manualisht.',
    // Iter19 Task 3
    selected: 'I zgjedhur',
    // Iter19 Task 4 — popup i stilizuar për anulim abonimi.
    cancelSubConfirmTitle: 'Je i sigurt?',
    cancelSubConfirmBody: 'Ky abonim do të anulohet menjëherë.',
    cancelSubConfirmOk: 'Anulo abonimin',
    // Iter30 — Numri i Kartës VIP + krijim dinamik abonimesh
    vipCardNumberLabel: 'Numri i Kartës VIP',
    vipCardNumberPlaceholder: 'p.sh. 1234567890',
    vipCardNumberHelp: 'Vendos numrin që shfaqet në terminalin Awoara kur afron kartën tënde VIP.',
    vipCardNumberHelpManager: 'Lexo numrin nga ekrani i terminalit Awoara dhe futeni këtu.',
    vipCardNumberSaved: 'Numri i kartës u ruajt',
    ocAddPlanCta: 'Shto Abonim të Ri',
    ocAddPlanTitle: 'Abonim i Ri',
    ocPlanFieldName: 'Emri i abonimit (për klientët)',
    ocPlanFieldNameEn: 'Emri i abonimit (English)',
    ocPlanFieldPrice: 'Çmimi (LEK/muaj)',
    ocPlanFieldWashes: 'Numri i larjeve të përfshira',
    ocPlanFieldProgram: 'Programi i lidhur',
    ocPlanFieldUnlimited: 'Abonim Unlimited (∞ larje)',
    ocPlanFieldEarnsVip: 'Akumulon pikë VIP',
    ocPlanFieldHidden: 'I fshehur (nuk shfaqet te klientët)',
    ocPlanCreated: 'Abonimi u krijua',
    ocPlanUpdated: 'Abonimi u përditësua',
    ocPlanDeleted: 'Abonimi u fshi',
    ocPlanDelete: 'Fshi abonimin',
    ocPlanEdit: 'Ndrysho',
    ocPlanHiddenBadge: 'I fshehur',
    // Iter19 Task 10 — Tab Abonentët në Admin.
    subscribersTab: 'Abonentët',
    subscribersSearchPlaceholder: 'Kërko sipas targës ose emrit',
    subscribersFilterAllPlans: 'Të gjitha planet',
    subscribersEmpty: 'Asnjë abonim aktiv akoma.',
    subscribersOriginApp: 'App',
    subscribersOriginCash: 'Cash',
    subscribersOriginWalkin: 'Walk-in',
    subscribersActivatedOn: 'Aktivizuar',
    subscribersExpiresOn: 'Skadon',
    subscribersWashesLeft: 'Larje të mbetura',
    // Iter19 Task 11
    perm_view_subscribers: 'Shiko abonentët aktivë',
    perm_view_customers: 'Shiko Klientët (CRM)',
    // Iter15 Task 9 — vehicle delete confirm
    removeVehicleTitle: 'Hiq mjetin?',
    removeVehicleDesc: 'Do të heqësh',
    remove: 'Hiq',
    cancel: 'Anulo',
    vehicleRemoved: 'Mjeti u hoq',
    // Iter15 Task 10 — admin revenue chart
    revenueByType: 'Të Ardhurat sipas Llojit',
    txType_single_wash: 'Larje e vetme',
    txType_subscription: 'Abonim',
    txType_cash_subscription: 'Abonim me cash',
    txType_interior: 'Brendësi',
    txType_manual_wash: 'Larje manuale',
    txType_card_payment: 'Pagesë me kartë',
    txType_card_subscription: 'Abonim me kartë',
    txType_cash_subscription_refund: 'Rimbursim abonimi me cash',
    todayRevenue: 'Të Ardhurat Sot',
    // Iter16 Task 9 — Users sub-tabs
    staffTab: 'Stafi',
    selected: 'të zgjedhura',
    bulkDeleteConfirm: 'Fshi rreshtat e zgjedhur?',
    bulkDeleteCta: 'Fshi',
    // Iter17
    subOnePlateWarning: 'Abonimi vlen vetëm për një targë. Zgjidh me kujdes — nuk mund të zhvendoset më vonë.',
    name: 'Emri',
    password: 'Fjalëkalimi',
    perm_add_employees: 'Shto punonjës të rinj',
    perm_edit_program_prices: 'Ndrysho çmimet e programeve',
    perm_view_customer_video_links: 'Shiko linket e story-ve të klientëve',
    perm_view_employee_panel: 'Hap panelin e punonjësit',
    perm_edit_app_texts: 'Ndrysho tekstet e aplikacionit në vend',
    perm_register_interior_completed: 'Shëno brendësinë si të kryer',
    perm_view_daily_bonus: 'Shiko bonusin ditor',
    perm_view_monthly_bonus: 'Shiko bonusin mujor',
    perm_view_pending_requests: 'Shiko kërkesat në pritje',
    perm_view_marketing: 'Akses Marketing (lista WhatsApp)',
    perm_view_time_metrics: 'Shfaq metrikat e kohës (timer + grafikë)',
    perm_panel_enabled: 'Aktivizo Panelin e Punonjësit',
    perm_panel_enabled_manager: 'Aktivizo Panelin e Menaxherit',

    // Role-gating UI strings
    cashStaffInfo: 'Shko tek stafi ynë për të paguar me lekë në dorë. Stafi do të aktivizojë abonimin për ty.',
    copyFailed: 'Kopjimi dështoi — provoje sërish',
    vipUnlimitedTitle: 'Larje Pa Limit — pa kufi çdo 24 orë',
    vipUnlimitedSub: 'Plani yt të jep larje pa kufi. Nuk nevojiten pikë VIP.',
    confirmDeleteTitle: 'Je i sigurt?',
    confirmDeleteDesc: 'Ky veprim nuk kthehet.',
    delete: 'Fshi',
    deleted: 'U fshi',
    cancel: 'Anullo',
    deleteSelected: 'Fshi të zgjedhurat',
    contactsPlural: 'kontakte',
    // Timer
    start: 'Nis',
    // Seats & waitlist (Task 18)
    seatsOk: '{n} vende të lira',
    seatsWarn: 'Vetëm {n} vende të lira!',
    seatsDanger: 'Vetëm {n} vende — rezervo tani!',
    seatsFull: 'Lista e pritjes',
    joinWaitlist: 'Hyr në listën e pritjes',
    waitlistJoined: 'U shtove në listën e pritjes',
    waitlistAlreadyIn: 'Tashmë në listë — pozicioni',
    ocSeatsTitle: 'Vendet e Abonimeve',
    ocSeatsHelp: 'Konfiguro kapacitetin, vendet e lira dhe pragjet. Numri zbret automatikisht në çdo abonim të ri; varianti ±1/±2 i natës zbatohet në 03:00 UTC.',
    capacity: 'Kapaciteti',
    freeSeats: 'Vende të lira',
    warnThreshold: 'Pragu i paralajmërimit',
    dangerThreshold: 'Pragu i rrezikut',
    paymentsTitle: 'Pagesat',
    paymentsAppBlock: 'Pagesa në App',
    paymentsAppHelp: 'Pagesat me kartë në aplikacion nuk janë të disponueshme. Klientët paguajnë cash ose me POS në pikë — abonimet aktivizohen manualisht nga administratori.',
    raiffeisenGateway: 'Raiffeisen Gateway',
    raiffeisenMerchantId: 'ID e Tregtarit',
    raiffeisenApiKey: 'Çelësi API',
    raiffeisenWebhookUrl: 'URL e Webhook',
    cashAlwaysOn: 'Cash gjithmonë i disponueshëm',
    vipRewardPopupTitle: 'Urime!',
    vipRewardPopupBody: 'Ke fituar 1 larje Standard FALAS! Eja te AutoSpa5 — kamera njeh targën dhe larja fillon vetë.',
    vipRewardCredit: 'Ke {n} larje Standard falas në pritje',
    portalScaloOrder: 'Renditja te portali: 1) premio falas, 2) abonim, 3) pagesë e vetme',
    renewalExpiringTitle: '⚠️ Abonimi yt po skadon',
    renewalExpiring5dBody: 'Abonimi yt skadon për {n} ditë. Eja në AutoSpa5 për ta rinovuar me lekë ose me POS në pikë.',
    renewalExpiring1dBody: '⚠️ Nesër humb aksesin — rinovoje sot!',
    renewalExpiredTitle: 'Abonimi yt ka skaduar',
    renewalExpiredBody: 'Rinovoje për të mos humbur vendin — lista e pritjes është aktive.',
    renewWithCard: 'Rinovo me kartë',
    renewLater: 'Më vonë',
    rolesAppTexts: 'Tekstet e aplikacionit — ndryshoji në vend',
    rolesAppTextsHelp: 'Tërhiq për t\'i rirenditur. Kliko çdo tekst për ta ndryshuar për secilën gjuhë.',
    counterFloorLabel: 'Numri minimal i kontatorit',

    // Integrations
    awoaraTitle: 'Awoara (Terminale)',
    awoaraDesc: 'Sinkronizo terminalin cash + kartë',
    anprTitle: 'Telekamera ANPR',
    anprDesc: 'Njohje automatike e targave',
    posBankarTitle: 'POS Bankar',
    posBankarDesc: 'Lidhje direkte POS me bankën tënde (BKT, Credins, Raiffeisen…)',
    fieldMerchantId: 'Merchant ID',
    fieldApiKey: 'Çelësi API',
    fieldWebhookUrl: 'URL Webhook',
    fieldCameraIp: 'IP i telekamerës',
    fieldEndpointUrl: 'URL i endpoint-it',
    fieldBankName: 'Emri i bankës',
    fieldTerminalId: 'Terminal ID (TID)',
    fieldHostIp: 'IP i bankës (Host)',
    fieldPort: 'Porta',

    // Subscription dates & expiring popups
    plateRequired: 'Targa (e detyrueshme)',
    subValidFrom: 'Aktiv nga',
    subValidTo: 'Skadon më',
    subExpiringSoonTitle: 'Abonimenti juaj skadon së shpejti!',
    subExpiringSoonBody: 'Rinovo tani që të mos i humbasësh përfitimet.',
    subExpiredTitle: 'Abonimenti juaj ka skaduar',
    subExpiredBody: 'Rinovo tani që të ruash çmimin VIP dhe përfitimet.',
    payNowCash: 'Paguaj me cash',
    notNow: 'Jo tani',
    daysLeft: '{n} ditë të mbetura',
    expired: 'Skaduar',

    // Delete user
    deleteUserBtn: 'Fshi',
    deleteUserConfirmTitle: 'Jeni i sigurt?',
    deleteUserConfirmBody: 'Ky veprim do të fshijë përgjithmonë llogarinë e përdoruesit.',
    deleteUserBlocked: 'Ky përdorues ka një abonim aktiv',
    deleteUserCancel: 'Anulo',
    deleteUserOK: 'Po, fshi',
    perm_delete_users: 'Fshi përdoruesin',

    // VIP share template
    vipShareHeadline: 'Kam aktivizuar Kartën VIP AutoSpa5!',
    vipDownloadShareImage: 'Shkarko imazhin për të ndarë',
    vipShareNow: 'Ndaj tani',
    vipShareImageReady: 'Gati për publikim! Ruaje dhe ngarkoje si story.',

    // Subscription pay with cash (via staff)
    payWithCashStaff: 'Paguaj me lekë në dorë tek stafi ynë',
    whatsappNumber: 'Numri WhatsApp',
    whatsappRecoveryHint: 'Nevojitet për të rikuperuar llogarinë',
    emailRecoveryHint: 'Vendos emailin tënd për të marrë kodin 6-shifror',
    forgotPassword: 'Harruat fjalëkalimin?',
    recoverAccount: 'Rikupero llogarinë',
    sendCodeButton: 'Dërgo kodin',
    verifyCodeButton: 'Verifiko & vendos fjalëkalimin e ri',
    enterOtp: 'Vendos kodin 6-shifror',
    newPassword: 'Fjalëkalimi i ri',
    otpSent: 'Nëse emaili është i regjistruar, kodi është dërguar.',
    accountRecovered: 'Fjalëkalimi u përditësua. Mund të hysh tani.',

    // Referral steps
    referralStep1Title: 'Ndaj kodin tënd',
    referralStep1Desc: 'Dërgo kodin unik miqve përmes WhatsApp, Facebook, Instagram ose linku.',
    referralStep2Title: 'Miku regjistrohet',
    referralStep2Desc: 'Ai/ajo regjistrohet me kodin tënd të referimit (falas, pa kartë).',
    referralStep3Title: 'Miku kryen larjen e parë',
    referralStep3Desc: 'Shpërblimi aktivizohet vetëm pasi makina e tij të lahet realisht.',
    referralStep4Title: 'Të dy merrni shpërblim',
    referralStep4Desc: 'Ai/ajo merr 1 Basic falas; ti merr 1 Standard falas për çdo 5 miq që kryejnë larjen (maks 10 shpërblime/muaj).',

    // Referral page — new 4-step layout (Task 13, iter13)
    inviteFriendsTitle: 'Fto Miqtë',
    inviteFriendsLead: 'Shpërnda linkun tënd, fito larje Standard falas.',
    referralStepNew1Title: 'Hapi 1: Kopjo linkun tënd më poshtë.',
    referralStepNew1Desc: 'Përmban kodin tënd unik të ftesës.',
    referralStepNew2Title: 'Hapi 2: Dërgoja një miku',
    referralStepNew2Desc: 'WhatsApp, Facebook, Instagram ose TikTok — me një prekje.',
    referralStepNew3Title: 'Hapi 3: Miku regjistrohet me linkun tënd dhe bën larjen e parë me pagesë.',
    referralStepNew3Desc: 'Lidhet automatikisht me llogarinë tënde.',
    referralStepNew4Title: 'Hapi 4: Miku merr 1 larje Standard FALAS. Ti merr 1 larje Standard FALAS për çdo 5 miq që lajnë makinën!',
    referralStepNew4Desc: 'Vetëm larje reale. Maks 10 shpërblime / muaj.',
    copyLink: 'Kopjo Linkun',
    copiedShort: 'U kopjua!',
    shareWith: 'Shpërnda me',
    toNextReward: 'deri te shpërblimi i ardhshëm',
    standardWashesFree: 'Larje Standard falas',
    progressToNextReward: 'Progresi deri te shpërblimi i ardhshëm',
    keepInviting: 'Vazhdo të ftosh — gati ke arritur!',

    // Referral shareable banner (editable from Paneli Kryesor → Rolet)
    referralBannerText: 'Fto 5 miq — merr 1 larje Standard FALAS. Miku yt merr 1 larje Basic FALAS kur bën larjen e parë.',
    referralBannerShared: 'Baneri u kopjua — gati për tu shpërndarë!',

    // Marketing tab
    marketingTab: 'Marketing',
    marketingWhatsappTitle: 'Lista WhatsApp e klientëve',
    marketingWhatsappDesc: 'Të gjithë klientët që kanë regjistruar një numër WhatsApp — i eksportueshëm.',
    marketingExportCsv: 'Eksporto CSV',
    marketingTotal: '{n} klientë',
    marketingNoData: 'Asnjë klient me WhatsApp ende.',
    
    // VIP social
    vipShareTitle: 'Shpërnda për të aktivizuar kartën',
    vipShareInstruction: 'Posto një story në Instagram ose TikTok duke etiketuar @autospa5.',
    vipNoStoryNoCard: 'Pa postuar storyn, karta VIP nuk aktivizohet.',
    vipStoryLinkPlaceholder: 'Ngjit linkun e videos (opsional)',
    vipIPostedStory: 'Kam postuar storyn',
    vipActivated: 'Karta VIP u aktivizua — faleminderit për shpërndarjen!',
    // Subscription pricing
    perWashOnly: 'Paguan vetëm {price} Lek për larje',
    monthlySubscription: 'Abonimi është mujor',
    unusedWashesNotice: 'Larjet e papërdorura nuk shtohen në muajin pasardhës.',
    
    // Common
    loading: 'Duke ngarkuar...',
    success: 'Sukses',
    back: 'Kthehu',
    selectCar: 'Zgjidh Automjetin',
    pleaseSelectCar: 'Ju lutem zgjidhni një automjet',
    paymentMocked: 'Modalitet Demo',
    // ====== Iter22 — Multi-location / Detailing / Bookings / CRM / AI (sq) ======
    detailingTab: 'Opsionet',
    totalUsersTab: 'Përdorues Total',
    bookingsTab: 'Rezervime',
    detailingMasterHelp: 'Kur është NDEZUR, shërbimet Liquid Glass bëhen të rezervueshme dhe një bllok i ri Detailing shfaqet për klientin.',
    upsellLiquidGlassTitle: 'Provo Liquid Glass — i rekomanduar për ty',
    upsellLiquidGlassBody: 'Ke bërë 8+ larje premium në 60 ditët e fundit. Hidh makinës shkëlqim ceramik 3 vjet.',
    crmTotalSpent: 'Shpenzime totale',
    crmWashCount: 'Larje',
    crmReviewStatus: 'Recensimi',
  },
  it: {
    // Navigation
    home: 'Home',
    programs: 'Programmi',
    subscriptions: 'Abbonamenti',
    myCar: 'Auto',
    history: 'Cronologia',
    account: 'Account',
    admin: 'Admin',
    
    // Auth
    login: 'Accedi',
    register: 'Registrati',
    logout: 'Esci',
    email: 'Email',
    password: 'Password',
    name: 'Nome',
    phone: 'Telefono',
    confirmPassword: 'Conferma Password',
    forgotPassword: 'Password Dimenticata?',
    noAccount: "Non hai un account?",
    haveAccount: 'Hai già un account?',
    signUp: 'Registrati',
    signIn: 'Accedi',
    continueWith: 'Oppure continua con',
    
    // Home & Brand
    welcome: 'Benvenuto',
    mainSlogan: 'Risparmia tempo. Risparmia soldi.',
    washIn5Min: 'Lavaggio automatico in 5 minuti',
    noScratches: 'Nessun graffio garantito',
    stayInCar: 'Resta in auto o scendi entro 15 secondi',
    plateRecognition: 'Riconoscimento targa per pagamenti online e abbonati',
    plateRecognitionShort: 'Riconoscimento targa',
    quickActions: 'Azioni Rapide',
    buyWash: 'Compra Lavaggio',
    subscribe: 'Abbonati',
    startNow: 'Inizia Ora',
    discoverVipCard: 'Scopri la Carta VIP',
    vipCardTitle: 'Carta VIP',
    vipCardSubtitle: 'Ogni 7.000 Lek ti regala 1 lavaggio gratis',
    freeBadge: 'GRATIS',
    freeWashesCount_one: 'Hai {n} lavaggio gratis',
    freeWashesCount_other: 'Hai {n} lavaggi gratis',
    
    // Chip translations
    chipWheels: 'Ruote & sottoscocca',
    chipHighPressure1: 'Alta pressione ×1',
    chipHighPressure2: 'Alta pressione ×2',
    chipPreWashFoam: 'Schiuma prelavaggio',
    chipActiveFoam: 'Schiuma attiva PRO',
    chipSpotlessDry: 'Asciugatura PRO senza macchie',
    chipNoDrying: '⚠️ SENZA ASCIUGATURA',
    chipSpotlessDrySimple: 'Asciugatura senza macchie',
    chipTireShine: 'Lucidatura gomme ✨',
    chipQiri: 'Cera protettiva (Qiri) contro sale & polvere 🛡️',
    chipNanoWax: 'NANO WAX — effetto specchio extra ✨',
    nanoWaxBullet1: 'L\'acqua scivola via da sola 💧',
    nanoWaxBullet2: 'Protegge da sole & salsedine ☀️🌊',
    nanoWaxBullet3: 'Brillantezza fino a 7 giorni ✨',
    luxuryComboLabel: 'Luxury + Pulizia interni',
    luxuryComboHours: '07:00–19:00',
    
    // Programs
    washPrograms: 'Programmi di Lavaggio',
    selectProgram: 'Seleziona un Programma',
    minutes: 'min',
    lek: 'Lek',
    mostPopular: 'Il più scelto',
    theBestUnlimited: 'Il Migliore',
    
    // Program Subtitles
    fastSubtitle: 'Risciacquo Veloce',
    basicSubtitle: 'Pulizia Essenziale',
    economicSubtitle: 'Scelta Intelligente',
    standardSubtitle: 'Cura Completa',
    luxurySubtitle: 'Brillantezza da Showroom',
    
    // Program Descriptions
    fastDesc: 'Risciacquo Rapido',
    basicDesc: 'Pulizia Essenziale',
    economicDesc: 'Scelta Intelligente',
    standardDesc: 'Cura Completa',
    luxuryDesc: 'Brillantezza da Showroom',
    
    // Subscriptions
    subscriptionPlans: 'Piani di Abbonamento',
    perMonth: '/mese',
    washes: 'lavaggi',
    unlimited: 'Illimitato',
    everyHours: 'ogni 24h',
    currentPlan: 'Piano Attuale',
    subscribePlan: 'Abbonati ora →',
    unlimitedHint: 'ogni 24h',
    unlimitedHomeTagline: '∞ Lavaggi senza limiti · ogni 24h',
    washesRemaining: 'Rimanenti',
    washesUsed: 'Usati',
    washesIncluded: 'Inclusi',
    youSave: 'Risparmi',
    normalPrice: 'Prezzo normale',
    subscriptionPrice: 'Abbonamento',
    
    // My Car
    myCars: 'I Miei Veicoli',
    addCar: 'Aggiungi Veicolo',
    licensePlate: 'Targa',
    make: 'Marca',
    noCars: 'Nessun veicolo registrato',
    autoEntry: 'Ingresso automatico al cancello',
    
    // History
    washHistory: 'Cronologia Lavaggi',
    noHistory: 'Nessuna cronologia',
    completed: 'Completato',
    
    // VIP
    vipCard: 'Carta VIP',
    progressToNext: 'Progresso Prossimo Lavaggio',
    useFreeWash: 'Usa Lavaggio Gratis',
    vipExplain: 'Ogni 7.000 Lek = 1 lavaggio gratis',
    vipMotivation: 'Quasi fatto! Continua così!',
    vipCongrats: 'Hai lavaggi gratis!',
    vipCardFront: 'Fronte',
    vipCardBack: 'Retro',
    vipHowItWorks: 'Come funziona la Carta VIP',
    vipPaymentTerminal: 'Paga con carta al terminale',
    vipPaymentTerminalDesc: 'Avvicina la carta al terminale on-site — il lavaggio viene registrato sul tuo profilo VIP.',
    vipPaymentCash: 'Paga in contanti alla macchina',
    vipPaymentCashDesc: 'I pagamenti in contanti vengono associati al VIP se la tua targa è registrata nell\'app.',
    vipDisclaimer: 'Ogni 7.000 Lek spesi ti regalano 1 lavaggio gratis. I lavaggi gratis non scadono finché l\'account resta attivo.',
    
    // Account
    editProfile: 'Modifica Profilo',
    language: 'Lingua',
    settings: 'Impostazioni',
    save: 'Salva',
    cancel: 'Annulla',
    
    // Payment
    paymentMethods: 'Metodi di Pagamento',
    addCard: 'Aggiungi Carta',
    cardNumber: 'Numero Carta',
    expiryDate: 'Data Scadenza',
    cvv: 'CVV',
    cardHolder: 'Nome Titolare',
    noCards: 'Nessun metodo di pagamento',
    defaultCard: 'Predefinita',
    
    // Referrals
    inviteFriends: 'Invita Amici',
    copyLink: 'Copia Link',
    friendsInvited: 'Amici Invitati',
    rewardsEarned: 'Premi Guadagnati',
    
    // Admin
    dashboard: 'Dashboard',
    totalUsers: 'Utenti Totali',
    activeSubscriptions: 'Abbonamenti Attivi',
    todayWashes: 'Lavaggi di Oggi',
    monthlyRevenue: 'Ricavi Mensili',
    totalCars: 'Veicoli Totali',
    revenueByType: 'Ricavi per Tipo',
    
    // CEO Dashboard
    revenueByType: 'Ricavi per Tipo',
    capacity: 'Capacità',
    // Iter20 Task 8
    subscriptionWindowLabel: 'Attivo',
    plansTab: 'Piani Abbonamento',
    ownerConsole: 'Pannello Principale',
    consoleRoles: 'Ruoli',
    consoleVip: 'VIP',
    autoSaved: 'Salvato automaticamente',
    saveChanges: 'Salva Modifiche',
    vipThresholdLabel: 'Soglia VIP (Lek)',
    vipRewardProgram: 'Programma premio VIP',
    secretSet: 'Chiave segreta impostata (nascosta)',
    addManager: 'Aggiungi Manager',
    addEmployee: 'Aggiungi Dipendente',
    
    // Subscription scarcity
    joinWaitlist: 'Entra in Lista d\'Attesa',
    onWaitlist: 'Sei in lista d\'attesa',
    unlimitedVehicleNote: 'Collegato a 1 veicolo registrato',
    
    // Stripe payments
    payingWithCard: 'Apertura pagamento sicuro…',
    paymentProcessing: 'Pagamento in elaborazione…',
    paymentSuccess: 'Pagamento riuscito',
    paymentSuccessDesc: 'Grazie! Il tuo acquisto è ora attivo.',
    paymentCancelled: 'Pagamento annullato',
    paymentCancelledDesc: 'Il pagamento è stato annullato. Nessun addebito.',
    paymentFailed: 'Pagamento non verificato',
    backToHome: 'Torna alla home',

    // Counter (HomePage social proof)
    counterTemplate: '{n} auto lavate questa settimana, la tua è ancora sporca?',

    // Role permissions (Italian)
    permsManagerHeader: 'Manager — cosa vede e cosa può fare',
    permsEmployeeHeader: 'Dipendente — cosa vede e cosa può fare',
    perm_view_daily_revenue: 'Vedere il fatturato giornaliero',
    perm_view_monthly_revenue: 'Vedere il fatturato mensile',
    perm_view_costs_margins: 'Vedere costi e margini',
    perm_register_cash_subscription: 'Registrare abbonamento cash',
    perm_cancel_subscription: 'Annulla abbonamenti',
    // Iter21 Task 7 (it)
    marketingOffers: 'Offerte',
    marketingPopups: 'Pop-up',
    settingsShort: 'Impostazioni',
    marketingSettingsTitle: 'Impostazioni marketing',
    marketingGoogleReviewUrl: 'URL Google Review',
    marketingReviewDiscount: 'Sconto recensione',
    // Iter21 Task 6
    bookingsTab: 'Prenotazioni',
    // Iter21 Task 8
    reviewRequest: 'Richiedi recensione',
    reviewRequestSent: 'Codice creato',
    reviewOpenWhatsApp: 'Apri WhatsApp',
    reviewStatusNotRequested: 'Non richiesta',
    reviewStatusRequested: 'Richiesta',
    reviewStatusCompleted: 'Lasciata ✅',
    reviewModalTitle: 'Richiesta recensione Google',
    reviewModalDesc: 'Generato un codice sconto unico per questo cliente. Condividi via WhatsApp.',
    reviewModalCode: 'Codice sconto',
    reviewModalDiscount: 'Sconto',
    reviewModalNoPhone: 'Nessun numero WhatsApp — condividi manualmente.',
    // Iter19 Task 3
    selected: 'Selezionato',
    // Iter19 Task 4
    cancelSubConfirmTitle: 'Sei sicuro?',
    cancelSubConfirmBody: 'Questo abbonamento verrà annullato immediatamente.',
    cancelSubConfirmOk: 'Annulla abbonamento',
    // Iter30 — Numero Carta VIP + creazione dinamica abbonamenti
    vipCardNumberLabel: 'Numero Carta VIP',
    vipCardNumberPlaceholder: 'es. 1234567890',
    vipCardNumberHelp: 'Inserisci il numero mostrato dal terminale Awoara quando avvicini la tua carta VIP.',
    vipCardNumberHelpManager: 'Leggi il numero dallo schermo del terminale Awoara e incollalo qui.',
    vipCardNumberSaved: 'Numero carta salvato',
    ocAddPlanCta: 'Aggiungi Abbonamento',
    ocAddPlanTitle: 'Nuovo Abbonamento',
    ocPlanFieldName: 'Nome piano (visibile ai clienti)',
    ocPlanFieldNameEn: 'Nome piano (English)',
    ocPlanFieldPrice: 'Prezzo (LEK/mese)',
    ocPlanFieldWashes: 'Lavaggi inclusi',
    ocPlanFieldProgram: 'Programma collegato',
    ocPlanFieldUnlimited: 'Piano Unlimited (∞ lavaggi)',
    ocPlanFieldEarnsVip: 'Accumula punti VIP',
    ocPlanFieldHidden: 'Nascosto (non visibile ai clienti)',
    ocPlanCreated: 'Piano creato',
    ocPlanUpdated: 'Piano aggiornato',
    ocPlanDeleted: 'Piano eliminato',
    ocPlanDelete: 'Elimina piano',
    ocPlanEdit: 'Modifica',
    ocPlanHiddenBadge: 'Nascosto',
    // Iter19 Task 10
    subscribersTab: 'Abbonati',
    subscribersSearchPlaceholder: 'Cerca per targa o nome',
    subscribersFilterAllPlans: 'Tutti i piani',
    subscribersEmpty: 'Nessun abbonamento attivo.',
    subscribersOriginApp: 'App',
    subscribersOriginCash: 'Cash',
    subscribersOriginWalkin: 'Walk-in',
    subscribersActivatedOn: 'Attivato',
    subscribersExpiresOn: 'Scade',
    subscribersWashesLeft: 'Lavaggi rimasti',
    // Iter19 Task 11
    perm_view_subscribers: 'Vedi abbonati attivi',
    perm_view_customers: 'Accesso Clienti (CRM)',
    // Iter15 Task 9 — vehicle delete confirm
    removeVehicleTitle: 'Rimuovi veicolo?',
    removeVehicleDesc: 'Verrà rimosso',
    remove: 'Rimuovi',
    cancel: 'Annulla',
    vehicleRemoved: 'Veicolo rimosso',
    // Iter15 Task 10 — admin revenue chart
    revenueByType: 'Ricavi per Tipo',
    txType_single_wash: 'Lavaggio singolo',
    txType_subscription: 'Abbonamento',
    txType_cash_subscription: 'Abbonamento cash',
    txType_interior: 'Interno',
    txType_manual_wash: 'Lavaggio manuale',
    txType_card_payment: 'Pagamento con carta',
    txType_card_subscription: 'Abbonamento con carta',
    txType_cash_subscription_refund: 'Rimborso abbonamento cash',
    todayRevenue: 'Ricavi di oggi',
    // Iter16 Task 9 — Users sub-tabs
    staffTab: 'Staff',
    selected: 'selezionati',
    bulkDeleteConfirm: 'Eliminare gli elementi selezionati?',
    bulkDeleteCta: 'Elimina',
    // Iter17
    subOnePlateWarning: 'L\'abbonamento vale per UNA SOLA targa. Scegli con attenzione — non potrà essere spostato in seguito.',
    name: 'Nome',
    password: 'Password',
    perm_add_employees: 'Aggiungere nuovi dipendenti',
    perm_edit_program_prices: 'Modificare i prezzi dei programmi',
    perm_view_customer_video_links: 'Vedere i link delle story dei clienti',
    perm_view_employee_panel: 'Accedere al pannello Dipendente',
    perm_edit_app_texts: 'Modificare i testi dell\'app in linea',
    perm_register_interior_completed: 'Segnare l\'interno come completato',
    perm_view_daily_bonus: 'Vedere il bonus giornaliero',
    perm_view_monthly_bonus: 'Vedere il bonus mensile',
    perm_view_pending_requests: 'Vedere le richieste in attesa',
    perm_view_marketing: 'Accesso Marketing (lista WhatsApp)',
    perm_view_time_metrics: 'Mostra metriche tempo (timer + grafici)',
    perm_panel_enabled: 'Abilita Pannello Dipendente',
    perm_panel_enabled_manager: 'Abilita Pannello Manager',

    // Role-gating UI strings
    cashStaffInfo: 'Vai dal nostro staff per pagare in contanti. Il team attiverà l\'abbonamento per te.',
    copyFailed: 'Copia non riuscita — riprova',
    vipUnlimitedTitle: 'Larje Pa Limit — illimitato ogni 24h',
    vipUnlimitedSub: 'Il tuo piano ti dà già lavaggi illimitati. Nessun punto VIP necessario.',
    confirmDeleteTitle: 'Sei sicuro?',
    confirmDeleteDesc: 'Questa azione non può essere annullata.',
    delete: 'Elimina',
    deleted: 'Eliminato',
    cancel: 'Annulla',
    deleteSelected: 'Elimina selezionati',
    contactsPlural: 'contatti',
    // Timer
    start: 'Avvia',
    // Seats & waitlist (Task 18)
    seatsOk: '{n} posti disponibili',
    seatsWarn: 'Solo {n} posti disponibili!',
    seatsDanger: 'Solo {n} posti — prenota ora!',
    seatsFull: 'Lista d\'attesa',
    joinWaitlist: 'Entra in lista',
    waitlistJoined: 'Aggiunto alla lista d\'attesa',
    waitlistAlreadyIn: 'Già in lista — posizione',
    ocSeatsTitle: 'Posti Abbonamenti',
    ocSeatsHelp: 'Configura capacità, posti liberi e soglie. Il contatore decrementa automaticamente; variazione notturna ±1/±2 alle 03:00 UTC.',
    capacity: 'Capacità',
    freeSeats: 'Posti liberi',
    warnThreshold: 'Soglia avviso',
    dangerThreshold: 'Soglia rischio',
    paymentsTitle: 'Pagamenti',
    paymentsAppBlock: 'Pagamenti In-App',
    paymentsAppHelp: 'I pagamenti con carta in-app non sono disponibili. I clienti pagano cash o POS in sede — gli abbonamenti si attivano manualmente dall\'admin.',
    raiffeisenGateway: 'Raiffeisen Gateway',
    raiffeisenMerchantId: 'Merchant ID',
    raiffeisenApiKey: 'API Key',
    raiffeisenWebhookUrl: 'Webhook URL',
    cashAlwaysOn: 'Cash sempre attivo',
    vipRewardPopupTitle: 'Complimenti!',
    vipRewardPopupBody: 'Hai vinto 1 lavaggio Standard GRATIS! Vieni in AutoSpa5 — la telecamera riconosce la targa e il lavaggio parte da solo.',
    vipRewardCredit: 'Hai {n} lavaggi Standard gratis in sospeso',
    portalScaloOrder: 'Ordine al portale: 1) premio gratis, 2) abbonamento, 3) pagamento singolo',
    renewalExpiringTitle: '⚠️ Il tuo abbonamento sta scadendo',
    renewalExpiring5dBody: 'Il tuo abbonamento scade tra {n} giorni. Vieni in AutoSpa5 per rinnovarlo in contanti o con POS in sede.',
    renewalExpiring1dBody: '⚠️ Domani perdi l\'accesso — rinnova oggi!',
    renewalExpiredTitle: 'Il tuo abbonamento è scaduto',
    renewalExpiredBody: 'Rinnova ora per non perdere il posto — la lista d\'attesa è attiva.',
    renewWithCard: 'Rinnova con carta',
    renewLater: 'Più tardi',
    rolesAppTexts: 'Testi dell\'app — modifica inline',
    rolesAppTextsHelp: 'Trascina per riordinare. Clicca su un testo per modificarlo per ogni lingua.',
    counterFloorLabel: 'Valore minimo del contatore',

    // Integrations
    awoaraTitle: 'Awoara (Terminale)',
    awoaraDesc: 'Sincronizzazione terminale contanti + carta',
    anprTitle: 'Telecamera ANPR',
    anprDesc: 'Riconoscimento automatico targhe',
    posBankarTitle: 'POS Bancario',
    posBankarDesc: 'Collegamento POS diretto alla tua banca (BKT, Credins, Raiffeisen…)',
    fieldMerchantId: 'Merchant ID',
    fieldApiKey: 'Chiave API',
    fieldWebhookUrl: 'URL Webhook',
    fieldCameraIp: 'IP della telecamera',
    fieldEndpointUrl: 'URL endpoint',
    fieldBankName: 'Nome banca',
    fieldTerminalId: 'Terminal ID (TID)',
    fieldHostIp: 'IP / Host acquirer',
    fieldPort: 'Porta',

    // Subscription dates & expiring popups
    plateRequired: 'Targa (obbligatoria)',
    subValidFrom: 'Attivo dal',
    subValidTo: 'Scade il',
    subExpiringSoonTitle: 'Il tuo abbonamento sta per scadere!',
    subExpiringSoonBody: 'Rinnova ora per non perdere i benefici VIP.',
    subExpiredTitle: 'Il tuo abbonamento è scaduto',
    subExpiredBody: 'Rinnova ora per ripristinare il prezzo VIP e i benefici.',
    payNowCash: 'Paga in contanti',
    notNow: 'Non ora',
    daysLeft: '{n} giorni rimasti',
    expired: 'Scaduto',

    // Delete user
    deleteUserBtn: 'Elimina',
    deleteUserConfirmTitle: 'Sei sicuro?',
    deleteUserConfirmBody: 'Questa azione elimina definitivamente l\'account utente.',
    deleteUserBlocked: 'Questo utente ha un abbonamento attivo',
    deleteUserCancel: 'Annulla',
    deleteUserOK: 'Sì, elimina',
    perm_delete_users: 'Elimina utenti',

    // VIP share template
    vipShareHeadline: 'Ho appena attivato la mia VIP Card AutoSpa5!',
    vipDownloadShareImage: 'Scarica immagine da condividere',
    vipShareNow: 'Condividi ora',
    vipShareImageReady: 'Pronta! Salvala e caricala come story.',

    // Subscription pay with cash (via staff)
    payWithCashStaff: 'Paga in contanti al nostro staff',
    whatsappNumber: 'Numero WhatsApp',
    whatsappRecoveryHint: 'Necessario per recuperare l\'account',
    emailRecoveryHint: 'Inserisci l\'email del tuo account per ricevere un codice a 6 cifre',
    forgotPassword: 'Password dimenticata?',
    recoverAccount: 'Recupera account',
    sendCodeButton: 'Invia codice',
    verifyCodeButton: 'Verifica & imposta nuova password',
    enterOtp: 'Inserisci il codice a 6 cifre',
    newPassword: 'Nuova password',
    otpSent: 'Se l\'email è registrata, il codice è stato inviato.',
    accountRecovered: 'Password aggiornata. Ora puoi accedere.',

    // Referral steps
    referralStep1Title: 'Condividi il tuo codice',
    referralStep1Desc: 'Invia il tuo codice unico agli amici tramite WhatsApp, Facebook, Instagram o link.',
    referralStep2Title: 'L\'amico si registra',
    referralStep2Desc: 'Si registra con il tuo codice referral (gratis, niente carta).',
    referralStep3Title: 'L\'amico completa il primo lavaggio',
    referralStep3Desc: 'Il premio si sblocca solo dopo che la sua auto è stata effettivamente lavata.',
    referralStep4Title: 'Entrambi ricevete un premio',
    referralStep4Desc: 'Lui/lei ottiene 1 Basic gratis; tu ottieni 1 Standard gratis ogni 5 amici che completano (max 10 premi/mese).',

    // Referral page — new 4-step layout (Task 13, iter13)
    inviteFriendsTitle: 'Invita Amici',
    inviteFriendsLead: 'Condividi il tuo link, ottieni lavaggi Standard gratis.',
    referralStepNew1Title: 'Passo 1: Copia il tuo link qui sotto.',
    referralStepNew1Desc: 'Contiene il tuo codice referral unico.',
    referralStepNew2Title: 'Passo 2: Inviato a un amico',
    referralStepNew2Desc: 'WhatsApp, Facebook, Instagram o TikTok — un tocco.',
    referralStepNew3Title: 'Passo 3: L\'amico si registra con il tuo link e fa il primo lavaggio a pagamento.',
    referralStepNew3Desc: 'Si collega automaticamente al tuo account.',
    referralStepNew4Title: 'Passo 4: L\'amico riceve 1 lavaggio Standard GRATIS. Tu ricevi 1 lavaggio Standard GRATIS ogni 5 amici che lavano l\'auto!',
    referralStepNew4Desc: 'Solo lavaggi reali. Max 10 premi / mese.',
    copyLink: 'Copia Link',
    copiedShort: 'Copiato!',
    shareWith: 'Condividi con',
    toNextReward: 'al prossimo premio',
    standardWashesFree: 'Lavaggi Standard gratis',
    progressToNextReward: 'Progresso al prossimo premio',
    keepInviting: 'Continua a invitare — ci sei quasi!',

    // Referral shareable banner (editable da Pannello → Ruoli)
    referralBannerText: 'Invita 5 amici — ricevi 1 lavaggio Standard GRATIS. Il tuo amico riceve 1 lavaggio Basic GRATIS al primo lavaggio.',
    referralBannerShared: 'Banner pronto da condividere!',

    // Marketing tab
    marketingTab: 'Marketing',
    marketingWhatsappTitle: 'Lista WhatsApp clienti',
    marketingWhatsappDesc: 'Tutti i clienti con un numero WhatsApp — esportabile.',
    marketingExportCsv: 'Esporta CSV',
    marketingTotal: '{n} clienti',
    marketingNoData: 'Nessun cliente con WhatsApp ancora.',
    
    // VIP social
    vipShareTitle: 'Condividi per attivare la carta',
    vipShareInstruction: 'Pubblica una story su Instagram o TikTok taggando @autospa5.',
    vipNoStoryNoCard: 'Senza pubblicare la story, la carta VIP NON viene attivata.',
    vipStoryLinkPlaceholder: 'Incolla il link del video (opzionale)',
    vipIPostedStory: 'Ho pubblicato la story',
    vipActivated: 'Carta VIP attivata — grazie per la condivisione!',
    // Subscription pricing
    perWashOnly: 'Paghi solo {price} Lek per lavaggio',
    monthlySubscription: 'L\'abbonamento è mensile',
    unusedWashesNotice: 'I lavaggi non utilizzati non si accumulano al mese successivo.',
    
    // Common
    loading: 'Caricamento...',
    success: 'Successo',
    back: 'Indietro',
    selectCar: 'Seleziona Veicolo',
    pleaseSelectCar: 'Per favore seleziona un veicolo',
    paymentMocked: 'Modalità Demo',
    // ====== Iter22 — Multi-location / Detailing / Bookings / CRM / AI (it) ======
    detailingTab: 'Opzioni',
    totalUsersTab: 'Utenti Totali',
    bookingsTab: 'Prenotazioni',
    detailingMasterHelp: 'Quando ATTIVO, i servizi Liquid Glass diventano prenotabili e un nuovo riquadro Detailing appare per il cliente.',
    upsellLiquidGlassTitle: 'Prova Liquid Glass — consigliato per te',
    upsellLiquidGlassBody: 'Hai fatto 8+ lavaggi premium negli ultimi 60 giorni. Regala alla tua auto una brillantezza ceramica di 3 anni.',
    crmTotalSpent: 'Spesa totale',
    crmWashCount: 'Lavaggi',
    crmReviewStatus: 'Recensione',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('autospa5-language');
    return saved || 'sq'; // Default to Albanian
  });
  const [cmsOverrides, setCmsOverrides] = useState({});

  useEffect(() => {
    localStorage.setItem('autospa5-language', language);
  }, [language]);

  // Load CMS overrides once on mount so Owner-edited texts surface across the app.
  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/cms/texts`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : {}))
      .then((data) => setCmsOverrides(data || {}))
      .catch(() => {});
  }, []);

  const cmsValue = (key) => {
    const row = cmsOverrides[key];
    if (!row) return null;
    const val = row[`value_${language}`];
    return val && val.trim() ? val : null;
  };

  const t = (key) => cmsValue(key) || translations[language]?.[key] || translations['en'][key] || key;

  // Iter21 Task 1 — localised date formatter. Pinned to the user's language so the
  // browser doesn't fall back to the system locale (was showing IT months by accident).
  const fmtDate = (iso, options = { day: '2-digit', month: 'long', year: 'numeric' }) => {
    if (!iso) return '—';
    try {
      const d = new Date(iso);
      const localeMap = { sq: 'sq-AL', en: 'en-US', it: 'it-IT' };
      return d.toLocaleDateString(localeMap[language] || 'sq-AL', options);
    } catch (err) {
      console.debug('[i18n] date format fallback', err?.message);
      return String(iso).slice(0, 10);
    }
  };

  // Translate a plural-aware phrase: looks up {key}_one / {key}_other and replaces {n}.
  const tn = (key, n) => {
    const variant = n === 1 ? `${key}_one` : `${key}_other`;
    const raw = cmsValue(variant)
      || translations[language]?.[variant]
      || translations['en'][variant]
      || cmsValue(key)
      || translations[language]?.[key]
      || translations['en'][key]
      || key;
    return raw.replace('{n}', n);
  };

  const cycleLanguage = () => {
    const langs = ['sq', 'en', 'it'];
    const currentIndex = langs.indexOf(language);
    const nextIndex = (currentIndex + 1) % langs.length;
    setLanguage(langs[nextIndex]);
  };

  const languageNames = {
    en: 'English',
    sq: 'Shqip',
    it: 'Italiano'
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, cycleLanguage, t, tn, fmtDate, languageNames, cmsOverrides, setCmsOverrides }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Helper to read a key directly from the static dictionary for a given language.
// Used by the Owner Console CMS editor to show the original default text per language.
export const getDictDefault = (key, lang) => {
  return translations[lang]?.[key] || translations['en'][key] || '';
};
